import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";

export default function ProductsPage() {
  const [serverProducts, setServerProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Statikus termékek (példa termékek)
  const staticProducts = [
    {
      id: 1,
      name: "Tinsel takaró",
      price: "30 990 Ft",
      image: "https://cdn.shopify.com/s/files/1/0613/3107/9307/files/DEQ25WES90984-122737_e417fa68839bf40ae826e10704d9d42c_dtl_1.jpg?v=1747907444",
      description: "Luxus takaró karácsonyi díszítéshez. Tökéletes kiegészítő a karácsonyi hangulathoz.",
      size: "150x200 cm",
      material: "100% pamut"
    },
    {
      id: 2,
      name: "Talvi hímzett párna",
      price: "14 990 Ft",
      image: "https://cdn.shopify.com/s/files/1/0613/3107/9307/files/DEQ25WES77234-638242_37a9585474facfeb7145304e2e75fd7b_dtl_1.jpg?v=1752491728",
      description: "Kézzel hímzett karácsonyi párna. Egyedi design és kiváló minőség.",
      size: "45x45 cm",
      material: "100% pamut"
    },
    {
      id: 3,
      name: "Helia hímzett párna",
      price: "17 990 Ft",
      image: "https://cdn.shopify.com/s/files/1/0613/3107/9307/files/DEQ25WES63708-184820_68f55f76636d5adee243d2ff2e76346f_dtl_1.jpg?v=1747306175",
      description: "Modern hímzett design. Stílusos kiegészítő minden otthonhoz.",
      size: "50x50 cm",
      material: "100% pamut"
    },
    {
      id: 4,
      name: "Bombom karácsonyi párna",
      price: "23 990 Ft",
      image: "https://cdn.shopify.com/s/files/1/0613/3107/9307/files/DEQ25WES52047-110256_c118ed79803a4a2c5670b66ded2b8d2a_dtl_1.jpg?v=1757683770",
      description: "Divatos karácsonyi mintával. Elegáns és hangulatos kiegészítő.",
      size: "40x40 cm",
      material: "100% pamut"
    },
    {
      id: 5,
      name: "Modern fotel",
      price: "89 990 Ft",
      image: "/images/1760610881360-405491391-8f9e95b8-4c3a-46f0-bf22-d1f0b97d50b7.jpg",
      description: "Kényelmes modern design fotel. Tökéletes a pihenéshez és kikapcsolódáshoz.",
      size: "85x95x75 cm",
      material: "Textil anyag"
    },
    {
      id: 6,
      name: "Asztali lámpa",
      price: "34 990 Ft",
      image: "/images/store-building.jpg",
      description: "Design asztali lámpa. Modern megvilágítás minden helyiséghez.",
      size: "40x40x60 cm",
      material: "LED izzóval"
    }
  ];

  // Szerver termékek betöltése
  useEffect(() => {
    loadServerProducts();
  }, []);

  const loadServerProducts = async () => {
    try {
      setLoading(true);
      const response = await fetch('http://localhost:3001/api/products');
      if (response.ok) {
        const data = await response.json();
        // Szerver termékek formázása a ProductsPage formátumára
        const formattedProducts = data.map(p => ({
          id: `server-${p.id}`, // Egyedi ID, hogy ne ütközzön a statikus termékekkel
          name: p.name,
          price: `${p.price.toLocaleString()} Ft`,
          image: `http://localhost:3001${p.imageUrl}`,
          description: p.description,
          size: p.size,
          material: `${p.color}, ${p.style}`,
          featured: p.featured,
          color: p.color,
          style: p.style
        }));
        setServerProducts(formattedProducts);
      }
    } catch (error) {
      console.error('Hiba a szerver termékek betöltésekor:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Initialize Feather icons
    if (window.feather) {
      window.feather.replace();
    }
  }, []);

  // Összes termék kombinálása (szerver termékek + statikus termékek)
  const products = [...serverProducts, ...staticProducts];

  return (
    <div className="bg-gray-50">

      {/* Product Grid */}
      <section className="container mx-auto px-4 sm:px-6 py-8 sm:py-10 md:py-12">
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6 sm:mb-8 text-gray-900">Termékeink</h1>
        
        {loading && (
          <div className="text-center py-12">
            <div className="inline-block w-12 h-12 border-4 border-gray-200 border-t-gray-900 rounded-full animate-spin mb-4"></div>
            <div className="text-base sm:text-lg text-gray-600">Termékek betöltése...</div>
          </div>
        )}
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-5 md:gap-6">
          {products.map((product) => (
            <div 
              key={product.id}
              className="product-card bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300"
            >
              <div className="relative">
                <img 
                  src={product.image} 
                  alt={product.name} 
                  className="w-full h-48 sm:h-52 md:h-56 object-cover" 
                  loading="lazy"
                />
                {product.featured && (
                  <div className="absolute top-2 right-2">
                    <span className="bg-yellow-500 text-white text-xs font-medium px-2 py-1 rounded shadow-md">Kiemelt</span>
                  </div>
                )}
              </div>
              <div className="p-3 sm:p-4">
                <h2 className="text-base sm:text-lg font-bold mb-1 sm:mb-2 text-gray-900 line-clamp-2 min-h-[2.5rem] sm:min-h-[3rem]">{product.name}</h2>
                <p className="text-base sm:text-lg font-semibold text-gray-800 mb-2 sm:mb-3">{product.price}</p>
                <p className="text-xs sm:text-sm text-gray-500 mb-3 line-clamp-2 leading-relaxed">{product.description}</p>
                <button 
                  className="w-full bg-black text-white py-2.5 sm:py-3 px-4 rounded-md hover:bg-gray-800 active:bg-gray-900 transition-colors text-sm sm:text-base font-medium"
                  onClick={(e) => {
                    e.stopPropagation();
                    alert('Termék hozzáadva a kosárhoz!');
                  }}
                >
                  Kosárba
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Footer */}
      <Footer />

    </div>
  );
}
